var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2.5","d":"M19 1.5 7.045 14.545 1 8.5"}));
}

Check.defaultProps = {"width":"20","height":"17","fill":"none"};

module.exports = Check;

Check.default = Check;
